module.exports = __webpack_public_path__ + "static/media/about img2.01c34574.png";